import { apiClient, BillSubscription, PostBillSubscriptionsRequest } from '@melio/javascript-sdk';

import { useCollectionApi, UseCollectionApiProps } from '../../core';
import { useCreateMutation } from '../../core/useCreateMutation';
import { BillSubscriptionCollection } from './types';

type UseBillSubscriptionsProps = UseCollectionApiProps<BillSubscription> & { params?: { ids?: string[] } };

export const useBillSubscriptions = (props: UseBillSubscriptionsProps = {}): BillSubscriptionCollection => {
  const client = apiClient.billSubscriptions();

  const query = useCollectionApi<BillSubscription, PostBillSubscriptionsRequest>({
    ...props,
    queryKey: ['bill-subscription', props.params],
    queryFn: () => (props.params?.ids ? Promise.all(props.params.ids.map((id) => client.get(id))) : client.fetch()),
  });

  const create = useCreateMutation<BillSubscription, PostBillSubscriptionsRequest>(client.create, query);

  return {
    ...query,
    create,
  };
};
